import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import Modal from 'components/Modal/Modal';
import SuccessCheckmark from 'components/SuccessCheckmark/SuccessCheckmark';
import { useMutationUpdateAccountManager } from 'Customers/hooks/useCustomers';

import AddAccountManagerForm from './AddAccountManagerForm';

const AddAccountManagerModal = ({ isOpen, onClose, id, users }) => {
  const queryClient = useQueryClient();
  const [error, setError] = useState(false);
  const { isLoading, mutate: updateAccountManager } = useMutationUpdateAccountManager();

  const initialValues = {};

  const handleSubmit = (data) => {
    updateAccountManager(
      { id, data },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries(['customersAccounts', id]);
        },
        onError: async () => {
          setError(true);
        },
      }
    );
    setTimeout(() => {
      setError(false);
      onClose();
    }, 1000);
  };
  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      title={'Assign account manager'}
      styles={{
        width: '560px',
        padding: 0,
        height: '480px',
      }}
      onRequestClose={() => {
        onClose();
      }}
    >
      {error && <SuccessCheckmark text={'Failed creating account manager'} isFailed={error} hideCloseButton />}
      <AddAccountManagerForm
        onClose={onClose}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        initialValues={initialValues}
        users={users?.data || []}
        failed={error}
      />
    </Modal>
  );
};

export default AddAccountManagerModal;
